import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage';

const CheckAuthorization = ({ roles, profiles, children }) => {
  const user = useSelector(state => state.auth.user);
  const isManagement = useSelector(state => state.auth.isManagement);

  const isAuthorized = (currentUser, requiredRoles) => {
    if (!requiredRoles.length) {
      return true;
    }

    const foundRole = requiredRoles.find(role => {
      return currentUser.roles.findIndex(userRoles => userRoles.name === role) > -1;
    });

    return !!foundRole;
  };

  const isProfileFound = (allProfiles, requiredProfile) => {
    return allProfiles.findIndex(profile => profile === requiredProfile) > -1;
  };

  const isValidProfile = () => {
    let requiredProfile = 'normal';
    if (isManagement) {
      requiredProfile = 'management';
    }

    return isProfileFound(profiles, requiredProfile);
  };

  if (!isValidProfile() || !isAuthorized(user, roles)) {
    return <ErrorMessage message="You don't have permission to access this page." showHomeLink />;
  }

  return children;
};

CheckAuthorization.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.object.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
  profiles: PropTypes.arrayOf(PropTypes.string)
};

CheckAuthorization.defaultProps = {
  profiles: ['normal', 'management']
};

export default CheckAuthorization;
